import { Injectable } from '@angular/core';

import * as mqtt from '../../assets/js/mqtt.min.js';

import { CommonService } from './common.service.js';

@Injectable({
  providedIn: 'root'
})
export class MqttService {

  client:any;
  constructor(private cm:CommonService) { }

  public connectMqtt(username,password,database){
    try {
      this.client.end();
      console.log('clear connect');
    } catch (error) {
    }
    

    this.client = mqtt.connect({
      host: 'waterlevelapp.iotdash.io',
      clean: true,
      connectTimeout: 4000,
      protocolVersion:4,
      port: 2083,
      protocol: 'wss',
      username: username,
      password: password
    });

    this.client.on('connect', () => {
      console.log('CONNECT');
      console.log(database);
      var option = {
        qos:0
      }

      for(var i = 0;i < database.length;i++){       
        this.client.subscribe('channel/'+database[i].uuid+'/waterlevel_status',option);
        this.client.subscribe('channel/'+database[i].uuid+'/waterlevel_lastupdate',option);

        this.client.subscribe('channel/'+database[i].uuid+'/waterlevel_raw',option);
        this.client.subscribe('channel/'+database[i].uuid+'/waterlevel',option);

        this.client.subscribe('channel/'+database[i].uuid+'/water_cal_slope',option);
        this.client.subscribe('channel/'+database[i].uuid+'/water_cal_constant',option);
        this.client.subscribe('channel/'+database[i].uuid+'/water_cal_offset',option);
      }
    });

    this.client.on('message',  (topic, message) => {
      console.log(topic + ": " + message);
      this.saveDataMqtt(topic,message.toString());
    });


    this.client.on("error", (error) => {
      console.log("ERROR: ", error);
    });
  
    this.client.on('offline', () => {
      console.log("offline");
    });
  
    var countReconnect = 0;
    this.client.on('reconnect', () => {
      countReconnect += countReconnect + 1;
      if(countReconnect >= 25){
        this.cm.toastr.warning('การเชื่อมต่อข้อมูลผิดพลาด','ผิดพลาด')
        this.client.end();
        this.cm.goto('login');
      }
      console.log("reconnect");
    });

  }

  public pub(topic,value){
    const option = {
      retain:true,
      qos:1
    }
    this.client.publish(topic,String(value),option);
  }

  public disconnect(){
    // console.log('disconnect');
    this.client.end();
  }

  data: any = [];
  saveDataMqtt(topic,value){
    let addNew = true;
    for(let i =0;i<this.data.length;i++){
      if(this.data[i].topic == topic){
        this.data[i].value = value;
        addNew = false
      }
    }
    if(addNew){
      this.data.push({
        topic:topic,
        value:value
      });
    }
  }

  show(topic){
    for(let i=0;i<this.data.length;i++){
      if(this.data[i].topic == topic){
        return this.data[i].value;
      }
    }
    return 'NC'
  }

}
